<template>
  <div class="bg-warning p-2">
    Keine Komponente über das "AttributeSchema" gefunden. Dieses Feld wurde falsch eingerichtet - bitte bei einem
    zuständigen Entwickler beschweren.
  </div>
  <div class="display-element">{{ value }}</div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: '' },
  },
  setup() {},
};
</script>
